import { render, staticRenderFns } from "./bankInfo.vue?vue&type=template&id=8764b2f0"
import script from "./bankInfo.vue?vue&type=script&lang=js"
export * from "./bankInfo.vue?vue&type=script&lang=js"
import style0 from "./bankInfo.vue?vue&type=style&index=0&id=8764b2f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports